export default "__VITE_ASSET__bXNxnxBH__"